<mat-dialog-content class="mat-typography">
	<div>
        <p>To replace the current audio file, please click on the actions drop-down from the My Shows page and select Replace Audio File</p>
	</div>
</mat-dialog-content>
<mat-dialog-actions align="end">
	<button class="cancel-popup" mat-stroked-button mat-dialog-close>Close</button>
</mat-dialog-actions>